import UserAuthorizationLayout from './UserAuthorizationLayout'
export default UserAuthorizationLayout
